import Vue from "vue";
import Vuex from "vuex";
import APIService from "@/services/APIService";
import {
  Stats
} from "fs";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    roomsBrief: [],
    roomsDetail: [],
    roomData: undefined,
    reservationStartDate: undefined,
    reservationEndDate: undefined,
    reserver: undefined,
    reserverTel: undefined,
    // reservationStartDate: new Date(2019, 7, 26),
    // reservationEndDate: new Date(2019, 7, 26),
    // reserver: 'bubble',
    // reserverTel: 1234567,
    reservationResult: undefined
  },
  mutations: {
    TOGGLE_LOADING_STATE(state) {
      state.isLoading = !state.isLoading;
    },
    SET_ROOMS_BRIEF(state, data) {
      state.roomsBrief = data;
    },
    PUSH_ROOMS_DETAIL(state, data) {
      state.roomsDetail.push(data);
    },
    SET_ROOM_DATA(state, data) {
      state.roomData = data;
    },
    SET_RESERVATION_START_DATE(state, value) {
      state.reservationStartDate = value;
    },
    SET_RESERVATION_END_DATE(state, value) {
      state.reservationEndDate = value;
    },
    UPDATE_RESERVER(state, value) {
      state.reserver = value;
    },
    UPDATE_RESERVER_TEL(state, value) {
      state.reserverTel = value;
    },
    SET_RESERVATION_RESULT(state, object) {
      state.reservationResult = object;
    },
    RESET_RESERVATION_DATE(state) {
      state.reservationStartDate = undefined;
      state.reservationEndDate = undefined;
    }
  },
  actions: {
    submitReservationForm({
      state,
      commit
    }) {
      const params = new window.URLSearchParams();
      params.append('name', state.reserver);
      params.append('tel', state.reserverTel);
      const dates = spreadDates(state.reservationStartDate, state.reservationEndDate);
      dates.forEach(date => {
        params.append('date[]', date)
      })
      commit('TOGGLE_LOADING_STATE');
      APIService.makeRoomReservation(state.roomData.room[0].id, params)
        .then(response => {
          commit('TOGGLE_LOADING_STATE');
          commit('SET_RESERVATION_RESULT', response);
        })
        .catch(function (error) {
          commit('TOGGLE_LOADING_STATE');
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            commit('SET_RESERVATION_RESULT', error.response);
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message);
          }
          // console.log(error.config);
        });

      function spreadDates(d0, d1) {
        const y = d0.getFullYear();
        const m = d0.getMonth();
        const d = d0.getDate();
        const deltaMilliSec = d1 - d0;
        const days = deltaMilliSec / 86400000;
        const dates = [];
        for (let i = 0; i < days + 1; i++) {
          dates.push(toAPIFormat(new Date(y, m, d + i)));
        }
        return dates
      }

      function toAPIFormat(date) {
        const y = date.getFullYear();
        let m = date.getMonth() + 1;
        if (m < 10) {
          m = `0${m}`;
        }
        let d = date.getDate();
        if (d < 10) {
          d = `0${d}`;
        }
        return y + '-' + m + '-' + d;
      }
    },
    getAllRoomsInfo(context) {
      context.commit("TOGGLE_LOADING_STATE");
      APIService.getAllRoomsInfo()
        .then(response => {
          const roomsBrief = response.data.items;
          context.commit("TOGGLE_LOADING_STATE");
          context.commit("SET_ROOMS_BRIEF", roomsBrief);
          return roomsBrief;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getRoomByID(context, id) {
      context.commit("TOGGLE_LOADING_STATE");
      APIService.getRoomByID(id).then(response => {
        context.commit("TOGGLE_LOADING_STATE");
        context.commit("SET_ROOM_DATA", response.data);
      });
    },
    deleteAllReservation(context) {
      context.commit("TOGGLE_LOADING_STATE");
      APIService.deleteAllReservation()
        .then(response => {
          context.commit("TOGGLE_LOADING_STATE");
          // console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
});